export default [
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../views/Login.vue'], resolve),
    meta: {
      auth: false
    }
  },
  {
    path: '/',
    name: 'companies',
    component: resolve => require(['../views/Companies.vue'], resolve),
    meta: {
      auth: true
    }
  },
  {
    path: '/user/:userId/detail',
    name: 'userDetail',
    component: resolve => require(['../views/user/Detail.vue'], resolve),
    meta: {
      auth: true
    }
  },
  {
    path: '/user/:userId/addCompany',
    name: 'addCompany',
    component: resolve => require(['../views/company/Add.vue'], resolve),
    meta: {
      auth: true
    }
  },
  {
    path: '/share/company/:companyId',
    name: 'companyUnauthorized',
    component: resolve => require(['../views/company/DetailUnauthorized.vue'], resolve),
    meta: {
      auth: false
    }
  },
  {
    path: '/share/service/:serviceId',
    name: 'serviceUnauthorized',
    component: resolve => require(['../views/service/DetailUnauthorized.vue'], resolve),
    meta: {
      auth: false
    }
  },

  // Company routes
  {
    path: '/company/:companyId',
    component: resolve => require(['../Company.vue'], resolve),
    children: [
      {
        path: 'addService',
        name: 'addService',
        component: resolve => require(['../views/service/Add.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'dashboard',
        name: 'companyAuthorized',
        component: resolve => require(['../views/Dashboard.vue'], resolve),
        meta: {
          auth: true,
          type: 'company'
        }
      },
      {
        path: 'settings',
        name: 'companySettings',
        component: resolve => require(['../views/company/Settings.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'edit',
        name: 'editCompany',
        component: resolve => require(['../views/company/Edit.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'reviews',
        name: 'companyReviews',
        component: resolve => require(['../views/company/Reviews.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: resolve => require(['../views/calendar/index.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'products',
        name: 'products',
        component: resolve => require(['../views/products/index.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: resolve => require(['../views/company/Notifications.vue'], resolve),
        meta: {
          auth: true
        }
      }
    ]
  },

  // Service routes
  {
    path: '/service/:serviceId',
    component: resolve => require(['../Service.vue'], resolve),
    children: [
      {
        path: 'dashboard',
        name: 'serviceAuthorized',
        component: resolve => require(['../views/Dashboard.vue'], resolve),
        meta: {
          auth: true,
          type: 'service'
        }
      },
      {
        path: 'settings',
        name: 'serviceSettings',
        component: resolve => require(['../views/service/Settings.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'edit',
        name: 'editService',
        component: resolve => require(['../views/service/Edit.vue'], resolve),
        meta: {
          auth: true
        }
      },
      {
        path: 'reviews',
        name: 'serviceReviews',
        component: resolve => require(['../views/service/Reviews.vue'], resolve),
        meta: {
          auth: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes/index.js